export default "__VITE_ASSET__HWx8gt7D__"